










































































































import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import vIcon from "../v-components/v-icon.vue";

export default Vue.extend({
  name: "DialogRequestResetPasswordExpired",
  components: { vIcon },
  props: {
    handleDismissDialog: {
      type: Function,
      required: false
    }
  },
  data: () => {
    return {
      email: "" as string,
      errors: {
        email_missing: false,
        email_notValid: false
      } as { [key: string]: boolean },
      status: "base" as string
    };
  },
  computed: {
    ...mapGetters(["GET_CSRF_INFORMATION"])
  },
  methods: {
    ...mapActions(["USER_REQUEST_PASSWORD_RESET"]),

    verifyEmail(email: string): boolean {
      const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    },

    handleFormSubmit(): void {
      this.status = "loading";
      if (this.preValidateFormData()) {
        this.$store
          .dispatch("USER_REQUEST_PASSWORD_RESET", {
            data: {
              email: this.email
            },
            token: this.GET_CSRF_INFORMATION.token
          })
          .then(() => {
            setTimeout(() => {
              this.status = "done";
            }, 500);
          })
          .catch(error => {
            this.status = "base";
            if (error.message === "Username or email is incorrect.") {
              this.status = "done";
            } else {
              this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
                status: true,
                component: "error"
              });
            }
          });
      } else {
        this.status = "base";
      }
    },

    preValidateFormData(): boolean {
      Object.keys(this.errors).forEach(key => (this.errors[key] = false));
      !this.email && (this.errors.email_missing = true);
      !this.verifyEmail(this.email) && (this.errors.email_notValid = true);
      return Object.keys(this.errors).every(key => !this.errors[key]);
    },

    resetState(): void {
      this.email = "";
      Object.keys(this.errors).forEach(key => (this.errors[key] = false));
      this.status = "base";
    }
  }
});
